import {RouterModule} from '@angular/router';
import {DexStreamingInitResolverService} from '../../components/dex/dex-streaming-init-resolver.service';
import {UserDataResolverService} from '../dashboard/user-data-resolver.service';
import {DetachedWidgetPageDefResolverService} from './detached-widget-page-def-resolver.service';
import {WatchlistsResolverService} from './watchlists-resolver.service';
import {WidgetPageComponent} from './widget-page.component';

export const WidgetPageRoutingModule = RouterModule.forChild([
    {
        path:      '',
        component: WidgetPageComponent,
        resolve:   {
            /**
             * Not all widgets may require it, but waiting for it here makes dependant widget appearing without delays.
             */
            streamingInit: DexStreamingInitResolverService,

            watchlists:            WatchlistsResolverService,
            detachedWidgetPageDef: DetachedWidgetPageDefResolverService,
            userData:              UserDataResolverService
        }
    }
]);
